import { AfterViewInit, Component } from '@angular/core';
import * as moment from 'moment';
import { interval } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
     selector: 'app-clock',
     templateUrl: './clock.component.html',
     styleUrls: ['./clock.component.scss'],
})
export class ClockComponent implements AfterViewInit {
     hour = '';
     seconds = '';

     ngAfterViewInit() {
          interval(1000)
               .pipe(
                    tap((value) => {
                         let d = moment();
                         this.hour = d.format('HH:mm');
                         this.seconds = d.format('ss');
                    })
                    // catchError(error => )
               )
               .subscribe();
     }
}
